import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
export function useNodeEdit({ props, state, }) {
    const { flow: { type }, } = props;
    const { setSelectState } = state;
    const onEdit = useCallback((node) => {
        const { nodeType } = node;
        if (nodeType === FlowNodeTypes.ACTION) {
            analytics.flowAddActionOpened({ flowType: type });
        }
        else {
            analytics.flowActionEditClicked({
                flowType: type,
                nodeType,
            });
        }
        setSelectState({ node });
    }, [setSelectState, type]);
    return onEdit;
}
